<template>
  <modal background>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button class="delete" aria-label="close" @click="doCancel"></button>
      </header>

      <section class="modal-card-body content" v-html="content" />

      <footer class="modal-card-foot">
        <button
          class="button"
          :class="proceed.type"
          @click="doProceed"
          v-if="proceed"
        >
          <icon :name="proceed.icon" v-if="proceed.icon" />
          <span v-if="proceed.content">{{ proceed.content }}</span>
        </button>
        <button
          class="button"
          :class="reject.type"
          @click="doReject"
          v-if="reject"
        >
          <icon :name="reject.icon" v-if="reject.icon" />
          <span v-if="reject.content">{{ reject.content }}</span>
        </button>
        <button
          class="button"
          :class="cancel.type"
          @click="doCancel"
          v-if="cancel"
        >
          <icon :name="cancel.icon" v-if="cancel.icon" />
          <span v-if="cancel.content">{{ cancel.content }}</span>
        </button>
      </footer>
    </div>
  </modal>
</template>

<script>
import { Modal } from "%modals";
import { Icon } from "%helpers";

export default {
  name: "yes-no-cancel-modal",

  components: {
    Modal,
    Icon
  },

  props: {
    title: String,
    content: String,
    proceed: Object,
    reject: Object,
    cancel: Object
  },

  methods: {
    hide() {
      this.$emit("hide");
    },

    doProceed() {
      this.proceed && this.proceed.callback && this.proceed.callback();
      this.hide();
    },

    doReject() {
      this.reject && this.reject.callback && this.reject.callback();
      this.hide();
    },

    doCancel() {
      this.cancel && this.cancel.callback && this.cancel.callback();
      this.hide();
    }
  }
};
</script>

<style lang="scss" scoped>
.content::v-deep blockquote,
.content::v-deep q {
  $background: darken($white, 4);
  background: $background;
  border-radius: $radius;
  border: solid 1px $background;
  padding: 1rem;
  margin: 1rem 0.1rem;
  color: $grey;
  font-style: italic;
}

.content::v-deep code {
  $background: darken($white, 4);
  background: $background;
  border-radius: $radius-small;
  border: solid 1px $background;
  color: $grey;
}
</style>
